import { simpleFetch } from './customFetch';

export const getOrders = () =>
  simpleFetch('/api/1/orders', {}, process.env.REACT_APP_MY_ACCOUNT_API);
